export default __webpack_public_path__ + "static/media/tooltip.e2ee5a92.svg";